export const EQUIPMENT_DIMENSIONS = [
        {
            id: "b1",
            block_id: "APLUS_LOZKO_POJEDYNCZE",
            default_x_length: 200,
            default_y_length: 100
        },
        {
            id: "b2",
            block_id: "APLUS_LOZKO_PODWOJNE",
            default_x_length: 200,
            default_y_length: 180
        },
        {
            id: "b21",
            block_id: "APLUS_LOZKO_PODWOJNE",
            default_x_length: 200,
            default_y_length: 180
        },
        {
            id: "b22",
            block_id: "APLUS_LOZKO_PODWOJNE",
            default_x_length: 200,
            default_y_length: 180
        },
        {
            id: "ba",
            block_id: "APLUS_WANNA",
            default_x_length: 160,
            default_y_length: 70
        },
        {
            id: "ba2",
            block_id: "APLUS_WANNA_2",
            default_x_length: 180,
            default_y_length: 70
        },
        {
            id: "ba3",
            block_id: "APLUS_WANNA_3",
            default_x_length: 180,
            default_y_length: 70
        },
        {
            id: "bb1",
            block_id: "APLUS_KOJEC_PROSTOKATNY",
            default_x_length: 150,
            default_y_length: 80
        },
        {
            id: "bi",
            block_id: "APLUS_BIDET",
            default_x_length: 54,
            default_y_length: 38
        },
        {
            id: "bp",
            block_id: "APLUS_LOZKO_PIETROWE",
            default_x_length: 208,
            default_y_length: 118
        },
        {
            id: "chd",
            block_id: "APLUS_KRZESLO_DZIECIECE",
            default_x_length: 50,
            default_y_length: 46
        },
        {
            id: "chh",
            block_id: "APLUS_HOKER",
            default_x_length: 44,
            default_y_length: 44
        },
        {
            id: "cho",
            block_id: "APLUS_KRZESLO_OBROTOWE",
            default_x_length: 74,
            default_y_length: 74
        },
        {
            id: "chp",
            block_id: "APLUS_KRZESLO_PODLOKIETNIK",
            default_x_length: 50,
            default_y_length: 45
        },
        {
            id: "chr",
            block_id: "APLUS_KRZESLO",
            default_x_length: 50,
            default_y_length: 45
        },
        {
            id: "dc",
            block_id: "APLUS_STOL_KAWOWY",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "de",
            block_id: "APLUS_BIURKO",
            default_x_length: 150,
            default_y_length: 80
        },
        {
            id: "de_dz",
            block_id: "APLUS_BIURKO",
            default_x_length: 150,
            default_y_length: 107
        },
        {
            id: "de_g",
            block_id: "APLUS_BIURKO",
            default_x_length: 150,
            default_y_length: 117
        },
        {
            id: "de_p",
            block_id: "APLUS_BIURKO",
            default_x_length: 150,
            default_y_length: 107
        },
        {
            id: "deo",
            block_id: "APLUS_BIURKO",
            default_x_length: 150,
            default_y_length: 117
        },
        {
            id: "dw",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "dw2",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 45
        },
        {
            id: "f1",
            block_id: "APLUS_SOFA_FOTEL",
            default_x_length: 97,
            default_y_length: 94
        },
        {
            id: "f2",
            block_id: "APLUS_SOFA_FOTEL",
            default_x_length: 97,
            default_y_length: 164
        },
        {
            id: "f3",
            block_id: "APLUS_SOFA_FOTEL",
            default_x_length: 97,
            default_y_length: 234
        },
        {
            id: "f4",
            block_id: "APLUS_SOFA_FOTEL",
            default_x_length: 97,
            default_y_length: 304
        },
        {
            id: "fm",
            block_id: "APLUS_FOTEL",
            default_x_length: 65,
            default_y_length: 65
        },
        {
            id: "fmp",
            block_id: "APLUS_FOTEL",
            default_x_length: 135,
            default_y_length: 65
        },
        {
            id: "fr",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "fr2",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 90
        },
        {
            id: "okp",
            block_id: "APLUS_OKAP",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "okw",
            block_id: "APLUS_OKAP",
            default_x_length: 40,
            default_y_length: 40
        },
        {
            id: "ov",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "r10",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 310,
            default_y_length: 130
        },
        {
            id: "r2",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 85,
            default_y_length: 135
        },
        {
            id: "r2_d8",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 85,
            default_y_length: 135
        },
        {
            id: "r3",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 135,
            default_y_length: 110
        },
        {
            id: "r3_d7",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 135,
            default_y_length: 110
        },
        {
            id: "r4",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 135,
            default_y_length: 135
        },
        {
            id: "r4_d7",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 135,
            default_y_length: 135
        },
        {
            id: "r5",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 110,
            default_y_length: 110
        },
        {
            id: "r5_d7",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 110,
            default_y_length: 110
        },
        {
            id: "r7",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 270,
            default_y_length: 130
        },
        {
            id: "r8",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 260,
            default_y_length: 130
        },
        {
            id: "re3",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 205,
            default_y_length: 105
        },
        {
            id: "re4",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 130,
            default_y_length: 130
        },
        {
            id: "re5",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 205,
            default_y_length: 130
        },
        {
            id: "sh",
            block_id: "APLUS_BRODZIK",
            default_x_length: 80,
            default_y_length: 80
        },
        {
            id: "shc",
            block_id: "APLUS_BRODZIK",
            default_x_length: 80,
            default_y_length: 80
        },
        {
            id: "shl",
            block_id: "APLUS_BRODZIK",
            default_x_length: 80,
            default_y_length: 80
        },
        {
            id: "si",
            block_id: "APLUS_ZLEW KUCHENNY BEZ OCIEKACZA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "si1",
            block_id: "APLUS_ZLEW KUCHENNY",
            default_x_length: 60,
            default_y_length: 100
        },
        {
            id: "si2",
            block_id: "APLUS_ZLEW KUCHENNY",
            default_x_length: 60,
            default_y_length: 150
        },
        {
            id: "si3",
            block_id: "APLUS_ZLEW KUCHENNY",
            default_x_length: 60,
            default_y_length: 84
        },
        {
            id: "si4",
            block_id: "APLUS_ZLEW KUCHENNY",
            default_x_length: 60,
            default_y_length: 130
        },
        {
            id: "si5",
            block_id: "APLUS_ZLEW KUCHENNY",
            default_x_length: 60,
            default_y_length: 105
        },
        {
            id: "sip",
            block_id: "APLUS_ZLEW KUCHENNY BEZ OCIEKACZA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "sn",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 174,
            default_y_length: 174
        },
        {
            id: "sn2",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 174,
            default_y_length: 254
        },
        {
            id: "sn22",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 254,
            default_y_length: 254
        },
        {
            id: "sn22d",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 254,
            default_y_length: 254
        },
        {
            id: "sn2d",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 174,
            default_y_length: 254
        },
        {
            id: "sn3",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 174,
            default_y_length: 334
        },
        {
            id: "sn32",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 254,
            default_y_length: 334
        },
        {
            id: "sn32d",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 254,
            default_y_length: 334
        },
        {
            id: "sn3d",
            block_id: "APLUS_NAROZNIK",
            default_x_length: 174,
            default_y_length: 334
        },
        {
            id: "st",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "st2",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 30
        },
        {
            id: "stv",
            block_id: "APLUS_SZAFA_POD_TV",
            default_x_length: 160,
            default_y_length: 40
        },
        {
            id: "sz",
            block_id: "APLUS_SZAFA",
            default_x_length: 60,
            default_y_length: 40
        },
        {
            id: "sz2",
            block_id: "APLUS_SZAFA2",
            default_x_length: 40,
            default_y_length: 60
        },
        {
            id: "szb",
            block_id: "APLUS_BIBLIOTEKA",
            default_x_length: 60,
            default_y_length: 40
        },
        {
            id: "szg",
            block_id: "APLUS_SZAFKA_GORNA",
            default_x_length: 60,
            default_y_length: 30
        },
        {
            id: "szk",
            block_id: "APLUS_KOMODA",
            default_x_length: 60,
            default_y_length: 37
        },
        {
            id: "szp",
            block_id: "APLUS_POLKA",
            default_x_length: 100,
            default_y_length: 25
        },
        {
            id: "szs",
            block_id: "APLUS_SZAFKA_SLUPEK",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "t2",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 116
        },
        {
            id: "t2_d7",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 116
        },
        {
            id: "t2_d8",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 116
        },
        {
            id: "t3",
            block_id: "APLUS_STOL_OKRAGLY",
            default_x_length: 145,
            default_y_length: 141
        },
        {
            id: "t3_d7",
            block_id: "APLUS_STOL_OKRAGLY",
            default_x_length: 145,
            default_y_length: 145
        },
        {
            id: "t4",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 142
        },
        {
            id: "t4_d7",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 142
        },
        {
            id: "t4_d8",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 150,
            default_y_length: 142
        },
        {
            id: "t5",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 176,
            default_y_length: 142
        },
        {
            id: "t5_d7",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 176,
            default_y_length: 142
        },
        {
            id: "t5_d8",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 176,
            default_y_length: 142
        },
        {
            id: "t6",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 202,
            default_y_length: 142
        },
        {
            id: "t6_d7",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 202,
            default_y_length: 142
        },
        {
            id: "t6_d8",
            block_id: "APLUS_STOL_KUCHENNY",
            default_x_length: 202,
            default_y_length: 142
        },
        {
            id: "t7",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 195,
            default_y_length: 130
        },
        {
            id: "t7_d8",
            block_id: "APLUS_STOL_PROSTOKATNY",
            default_x_length: 195,
            default_y_length: 140
        },
        {
            id: "tc",
            block_id: "APLUS_TABLE_ROUND",
            default_x_length: 90,
            default_y_length: 90
        },
        {
            id: "tc5",
            block_id: "APLUS_STOL_OKRAGLY",
            default_x_length: 178,
            default_y_length: 178
        },
        {
            id: "tc6",
            block_id: "APLUS_STOL_OKRAGLY",
            default_x_length: 177,
            default_y_length: 178
        },
        {
            id: "tn",
            block_id: "APLUS_STOLIK_NOCNY",
            default_x_length: 50,
            default_y_length: 40
        },
        {
            id: "tv",
            block_id: "APLUS_STOL_TV",
            default_x_length: 160,
            default_y_length: 40
        },
        {
            id: "tvo",
            block_id: "APLUS_STOL_TV",
            default_x_length: 120,
            default_y_length: 8
        },
        {
            id: "tvs",
            block_id: "APLUS_STOL_TV",
            default_x_length: 120,
            default_y_length: 8
        },
        {
            id: "va",
            block_id: "APLUS_TOALETKA",
            default_x_length: 100,
            default_y_length: 50
        },
        {
            id: "wb",
            block_id: "APLUS_UMYWALKA",
            default_x_length: 45,
            default_y_length: 60
        },
        {
            id: "wb2",
            block_id: "APLUS_UMYWALKA_PODWOJNA",
            default_x_length: 45,
            default_y_length: 150
        },
        {
            id: "wb_l",
            block_id: "APLUS_UMYWALKA",
            default_x_length: 45,
            default_y_length: 70
        },
        {
            id: "wba",
            block_id: "APLUS_UMYWALKA_ASYMETRYCZNA",
            default_x_length: 25,
            default_y_length: 40
        },
        {
            id: "wc",
            block_id: "APLUS_TOALETA_WC",
            default_x_length: 70,
            default_y_length: 43
        },
        {
            id: "wc2",
            block_id: "APLUS_TOALETA_WC",
            default_x_length: 53,
            default_y_length: 35
        },
        {
            id: "wc3",
            block_id: "APLUS_TOALETA_WC",
            default_x_length: 68,
            default_y_length: 60
        },
        {
            id: "wcg",
            block_id: "APLUS_TOALETA_WC",
            default_x_length: 15,
            default_y_length: 60
        },
        {
            id: "wm",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 60
        },
        {
            id: "wm2",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 45,
            default_y_length: 60
        },
        {
            id: "wm3",
            block_id: "APLUS_KUCHNIA",
            default_x_length: 60,
            default_y_length: 40
        }
    ]